import { Modal } from '@mantine/core';
import AssetsPicker from '../Assets/AssetsPicker';

const AiChatImagesPickModal = ({ imagesPickModalOpen, toggleImagesPickModal, addFile }) => {
  const confirm = (asset, _, cb) => {
    addFile(asset.url);
    cb();
  };
  return (
    <Modal size="lg" opened={imagesPickModalOpen} onClose={() => toggleImagesPickModal()} title="Choose an image to describe">
      <AssetsPicker
        pickUrl={addFile}
        addAsset={(asset, siteUrl) => confirm(asset, siteUrl, toggleImagesPickModal())}
        cancel={toggleImagesPickModal}
      />
    </Modal>
  );
};

export default AiChatImagesPickModal;
